import { Link as GatsbyLink } from 'gatsby'
import styled from 'styled-components'

import InformationIconSvg from '../../../../img/rewards/information-circle-fill.inline.svg'

export const InformationIcon = styled(InformationIconSvg)`
  width: 40px;
  margin-right: 16px;
  color: #48a2b0;
  flex-shrink: 0;
`

export const NoticeCard = styled.div`
  display: flex;
  align-items: center;
  background-color: #48a2b01a;
  border-radius: 8px;
  padding: 16px;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
`

export const NoticeText = styled.span`
  font-size: 16px;
`

export const NoticeLink = styled(GatsbyLink)`
  color: ${({ theme }) => theme.colors.royalBlue.shade500};
`
